import React from "react";
import "./PGAModelBuilderCalcTabs.css";
import PGAModelBuilderField from "../PGAModelBuilderField";
import Tabs from "../../../../../Tabs";
import { graphql, useLazyLoadQuery } from "react-relay";
import Select from "react-select";
import PGAModelBuilderInput from "../PGAModelBuilderInput";
import SelectField from "../../../../../SelectField";
import PGAModelBuilderCalcTab from "./PGAModelBuilderCalcTab";
import PGAModelBuilderModelPlayers from "../PGAModelBuilderModelPlayers";
import PGAModelBuilderCalcGlossary from "./PGAModelBuilderCalcGlossary";

const GET_CALCS = graphql`
  query PGAModelBuilderCalcTabsGetCalcsQuery($modelId: ID!) {
    calcFeaturesForPgaTourModel(modelId: $modelId) {
      id
      name
      calculation {
        id
        name
        classification {
          id
          name
        }
      }
      weight
    }

    pgaModelCalcClassifications {
      id
      name
    }

    pgaModelCalculations {
      id
      name
    }
  }
`;

export default function PGAModelBuilderCalcTabs(props) {
  let data;

  if (props.modelId) {
    data = useLazyLoadQuery(
      GET_CALCS,
      { modelId: props.modelId },
      { fetchPolicy: "network-only", fetchKey: props.calcReloads }
    );
  }

  // Prevent an empty array from being passed as a Tabs child below
  if (data && data.calcFeaturesForPgaTourModel.length === 0) {
    data = undefined;
  }

  return (
    <Tabs>
      <div label="Field" className="pga-model-builder-tab">
        <React.Suspense fallback="Loading field...">
          <PGAModelBuilderField slateId={props.selectedSlateId} />
        </React.Suspense>
      </div>
      <div label="Model Golfers" className="pga-model-builder-tab">
        {props.modelId ? (
          <React.Suspense fallback="Loading players...">
            <PGAModelBuilderModelPlayers
              modelID={props.modelId}
              inputReloads={props.inputReloads}
            />
          </React.Suspense>
        ) : null}
      </div>
      <div label="Glossary" className="pga-model-builder-tab">
        <React.Suspense fallback={"Loading glossary..."}>
          <PGAModelBuilderCalcGlossary />
        </React.Suspense>
      </div>
      {data
        ? data.calcFeaturesForPgaTourModel.map((feature, index) => {
            return (
              <PGAModelBuilderCalcTab
                label={feature.name}
                key={index}
                feature={feature}
                calcReloads={props.calcReloads}
                setCalcReloads={props.setCalcReloads}
                featureOutputReloads={props.featureOutputReloads}
              />
            );
          })
        : null}
    </Tabs>
  );
}
